import isClient from '@/utils/browser/isClient'
import { getAnalyticsPayload, getRedTesting } from '../analytics'

const VISITED_PAGE_NEW_RELIC = 'VisitedPage'

export const noticeError = (error) => {
  isClient() && window?.newrelic?.noticeError(error)
  return
}

export const setAttribute = (obj) => {
  Object.keys(obj).forEach((key) => {
    isClient() &&
      window?.newrelic?.interaction()?.setAttribute(key, obj[key])?.save()
  })
}

export const newRelicSetAttribute = ({ name, value }) => {
  isClient() &&
    window?.newrelic?.interaction()?.setAttribute(name, value)?.save()
  return
}

export const newRelicVisitedPage = () => {
  if (!isClient()) return

  const payload = getAnalyticsPayload()
  const hasTestAB = getRedTesting() || ''
  const urlParams = window.location.search
  const pathName = window.location.pathname

  window?.newrelic
    ?.interaction()
    ?.setName(VISITED_PAGE_NEW_RELIC)
    ?.setAttribute('tracrAnonymousId', payload.anonymous_id)
    ?.setAttribute('tracrSessionId', payload.session_id)
    ?.setAttribute('sourceUrl', payload.source_url)
    ?.setAttribute('urlParams', urlParams)
    ?.setAttribute('userAgent', payload.user_agent)
    ?.setAttribute('pathName', pathName)
    ?.setAttribute('experiments', hasTestAB)
    ?.save()
}

// Verify if NR is ready to use
export const handleNewRelicReady = () => {
  const _newRelicReadyInterval = setInterval(() => {
    if (!window.newrelic) return

    newRelicVisitedPage()
    clearInterval(_newRelicReadyInterval)
  }, 150)
}
